'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHost = setHost;
exports.getHost = getHost;
exports.isWebWorker = isWebWorker;
exports.provideBrowsingContext = provideBrowsingContext;
var host = 'frog.wix.com';

function setHost(_host) {
  host = _host;
}

function getHost() {
  return host;
}

function isWebWorker() {
  /* global WorkerGlobalScope */

  //At the moment, this is the most reliable way of detecting if current code is run in a worker
  //Taken from here: https://stackoverflow.com/a/18002694
  return typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope;
}

/**
 * Provides a window object to the callback iff current window is the topmost one
 * Otherwise returns null
 */
function provideBrowsingContext(cb) {
  if (typeof window !== 'undefined' && window) {
    try {
      return window.top === window.self ? cb ? cb(window) : window : null;
    } catch (e) {
      return null;
    }
  }

  return null;
}
//# sourceMappingURL=env.js.map



//////////////////
// WEBPACK FOOTER
// ./~/web-bi-logger/dist/src/lib/env.js
// module id = 203
// module chunks = 15 16 17 18 19